import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'suporte-assinatura-digital-modal',
  templateUrl: './suporte-assinatura-digital-modal.component.html',
  styleUrls: ['./suporte-assinatura-digital-modal.component.scss']
})
export class SuporteAssinaturaDigitalModalComponent {
  constructor(public bsModalRef: BsModalRef) {}
}
